"use client";
import Link from "next/link";
import { agbalumo } from "~/app/fonts";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useAppStore } from "~/store/app-store";
import { useUserStore } from "~/store/user-store";
import { AppI, CityI, UserI } from "~/interfaces";
import citiesData from "~/imports/cities.json";
import {
  BackButtonIcon,
  HeartIcon,
  MenuIcon,
  HeartFilledIcon,
} from "~/_components/icons";
import MainMenu from "~/_components/menus/main-menu";
import LikeMenu from "~/_components/menus/like-menu";

export default function Navbar() {
  const appStore: AppI = useAppStore((state) => state.app);
  const userStore: UserI = useUserStore((state) => state.user);
  const toggleMainMenu = useAppStore((state) => state.toggleMainMenu);
  const toggleLikeMenu = useAppStore((state) => state.toggleLikeMenu);
  const updateMenu = useAppStore((state) => state.updateMenu);
  const updatePathname = useAppStore((state) => state.updatePathname);
  const updateCity = useAppStore((state) => state.updateCity);
  const pathname = usePathname();

  // Get city from subdomain
  useEffect(() => {
    if (typeof window === "undefined") return;

    const hostname = window.location.hostname.split(".");
    const cityName =
      hostname.length > 1 && hostname[0] !== "www"
        ? hostname[0]?.toLowerCase()
        : undefined;

    if ((!appStore.city && cityName) || appStore.pathname !== pathname) {
      const selectedCity = citiesData.find((city) => city.name === cityName);
      updateCity(selectedCity);
      updatePathname(pathname);
      updateMenu({
        isBackButtonActive: pathname.includes("/listings"),
      });
    }
  }, [pathname, appStore.city, appStore.pathname]);

  return (
    <nav
      id="fun-navbar"
      className="sticky top-0 z-[100] flex h-14 w-full items-center justify-between lg:h-20"
    >
      <MainMenu />
      <LikeMenu />
      <div className="h-14 w-28 lg:h-20 lg:w-52">
        <span
          className="inline-block cursor-pointer p-2 lg:p-5"
          aria-label="toggle menu"
          onClick={toggleMainMenu}
        >
          <MenuIcon className="fun-svg-shadow-gray h-10 text-white" />
        </span>
      </div>

      <Link
        href="/"
        aria-label="homepage link"
        className={`${agbalumo.className} fun-logo relative -mt-[.4rem] inline-block text-[1.75rem] tracking-wider text-white lg:p-3 lg:text-[2.5rem]`}
      >
        {appStore.menu.isBackButtonActive && (
          <BackButtonIcon className="fun-svg-shadow-gray absolute -left-[32px] top-[2px] h-[30px] text-white lg:-left-[30px] lg:top-[17px] lg:h-10" />
        )}
        FundayList
      </Link>
      <div className="relative flex h-14 w-28 justify-end lg:h-20 lg:w-52">
        {appStore.city && (
          <span
            className="relative flex cursor-pointer items-center justify-center p-3 lg:p-5"
            aria-label="liked listings menu"
            onClick={toggleLikeMenu}
          >
            <span className="absolute z-10 -mt-1 text-[.9rem] font-[500] text-white lg:text-[1.1rem]">
              {userStore.likedListings.length}
            </span>
            {userStore.likedListings.length > 0 ? (
              <HeartFilledIcon className="fun-svg-shadow-gray h-8 fill-red lg:h-10" />
            ) : (
              <HeartIcon className="fun-svg-shadow-gray h-8 text-white lg:h-10" />
            )}
          </span>
        )}
      </div>
    </nav>
  );
}
